// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"384":"b0ed3561","647":"78b49833","688":"95663004","726":"95663004","934":"c253efa1"}[chunkId] + ".css";
};